import React from 'react';
import PrivacyScreen from 'components/Privacy/PrivacyScreen';

const Privacy = (): JSX.Element => <PrivacyScreen />;

export default Privacy;
